import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class FeatureFlagService {
    private headers() {
        return new HttpHeaders({
            'Authorization': `Bearer ${sessionStorage.getItem('authorizationData')}`
        })
    };

    private baseUrl = '/api/Features';

    constructor(protected httpClient: HttpClient) { }

    public getLatestFlags(){
        return this.httpClient.get(`${this.baseUrl}/Disabled`, { headers: this.headers() });
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/feature-flag.service.ts